import { startOfDay, endOfDay, addDays, parse } from "date-fns";

export default class Chart {
  start: Date;

  get end(): Date {
    return endOfDay(addDays(this.start, this.cols - 1));
  }

  get cols(): number {
    return this._cols;
  }

  get width(): number {
    return this._width;
  }

  set width(width: number) {
    if (width < 0) throw new Error("Invalid value");
    this._cols = Math.round(width / this.baseWidth);
    this._width = width;
  }

  get baseWidth(): number {
    return this._baseWidth;
  }

  set baseWidth(baseWidth: number) {
    if (baseWidth < 1) throw new Error("Invalid value");
    this._cols = Math.round(this.width / baseWidth);
    this._baseWidth = baseWidth;
  }

  get colWidth(): number {
    if (this.cols > 1) {
      return this.width / this.cols;
    } else {
      return this.baseWidth;
    }
  }

  constructor(start: Date, cols: number) {
    this.start = startOfDay(start);
    this._cols = cols;
  }

  move(cols: number) {
    this.start = addDays(this.start, cols);
  }

  moveDate(date: Date): void {
    this.start = date;
  }

  moveDateByNumbers(year: number, month: number = 1, date: number = 1) {
    const d = parse(`${year}-${month}-${date}`, "y-M-d", new Date());
    this.moveDate(d);
  }

  adjust(width: number) {
    this.width = width;
  }

  private _cols: number;
  private _width: number = 0;
  private _baseWidth: number = 35;
}
